<template>
  <div>
    <article class="con4">
      <div class="container">
        <p id="philHorizon" class="title-text">CARROT의 수평문화</p>
        <p class="sub-text">성공적인 수평 조직문화를 위한 3가지 핵심 요소</p>
        <ul>
          <li>
            <div class="inner">
              <img
                src="@/assets/img/newGlobal/introduce/sub/philosophy/con4/img0.png"
                alt="img"
              />
              <p>Positive Communication</p>

              <p>일상에서 긍정성을 통한<br />관계진전</p>
            </div>
          </li>
          <li class="line"></li>
          <li>
            <div class="inner">
              <img
                src="@/assets/img/newGlobal/introduce/sub/philosophy/con4/img1.png"
                alt="img"
              />
              <p>Collaboration</p>
              <p>긍정적 소통과 존중을 통해<br />협력과 시너지를 극대화</p>
            </div>
          </li>
          <li class="line"></li>
          <li>
            <div class="inner">
              <img
                src="@/assets/img/newGlobal/introduce/sub/philosophy/con4/img2.png"
                alt="img"
              />
              <p>Respect</p>
              <p>서로의 가치를 인정하고<br />존중하는 문화</p>
            </div>
          </li>
        </ul>
      </div>
    </article>
  </div>
</template>

<script>
import "@/assets/style/newGlobalReset.scss";

export default {};
</script>

<style lang="scss" scoped>
.con4 {
  padding: 40px 0;
  background: #f3f3f3;

  @media screen and (min-width: 1350px) {
    padding: 80px 0;
  }

  .title-text {
    font-size: 30px;
    font-weight: 700;
    text-align: center;
    margin-bottom: 20px;
  }

  .sub-text {
    font-size: 18px;
    text-align: center;
    margin-bottom: 20px;

    @media screen and (min-width: 1350px) {
      margin-bottom: 50px;
    }
  }

  ul {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    gap: 30px;

    @media screen and (min-width: 1350px) {
      display: flex;
      justify-content: center;
      gap: 0;
    }

    li {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 0;

      &.line {
        display: none;

        @media screen and (min-width: 1350px) {
          display: block;
          width: 100%;
          max-width: 135px;
          height: 1px;
          background-color: #000000;
          margin-top: 8%;
        }
      }

      .inner {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;

        img {
          margin-bottom: 10px;
        }

        p {
          &:nth-of-type(1) {
            font-weight: 700;
            color: #fe4818;
            margin-bottom: 10px;
          }

          &:nth-of-type(2) {
            font-size: 14px;
          }
        }
      }
    }
  }
}
</style>
